module.exports = __webpack_public_path__ + "img/dummy-news-1.4b7c11aa.jpg";